// src/pages/Home/components/FaqSection.js
//
// Bloco visível do FAQ na página inicial.
//
// O conteúdo NÃO mora aqui: vem de src/data/faq.js, que é a fonte única.
// O mesmo arquivo gera public/faq.html e o JSON-LD FAQPage do index.html
// (ver scripts/gerar-faq.js). Editar a resposta em um lugar só evita o
// pior cenário: o site dizer uma coisa para a pessoa e outra para a IA.

import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Link as MuiLink,
  Typography
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import Secao, { Leitura } from '../../../components/Layout/Secao'
import FAQ from '../../../data/faq'
import { evento } from '../../../analytics'

const FaqSection = () => {
  return (
    // Trilho xl como todo bloco da home; a coluna de leitura de 768px fica
    // DENTRO dele e encostada na esquerda (<Leitura>), nao centralizada.
    <Secao fundo='branco' ritmo='padrao'>
      <Leitura>
        <Typography
          component='h2'
          sx={{ fontSize: { xs: '1.35rem', md: '1.6rem' }, fontWeight: 700, mb: 0.5 }}
        >
          Perguntas frequentes
        </Typography>
        <Typography sx={{ color: 'text.secondary', mb: 3 }}>
          Como funciona anunciar no UMARKT.
        </Typography>

        {FAQ.map((item, i) => (
          <Accordion
            key={i}
            disableGutters
            elevation={0}
            defaultExpanded={i === 0}
            onChange={(_, aberto) => {
              // so o abrir interessa: mostra QUAL duvida trouxe a pessoa aqui
              if (aberto) evento('faq_aberto', { pergunta: item.p, posicao: i + 1 })
            }}
            sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              mb: 1.25,
              '&:before': { display: 'none' },
              '&.Mui-expanded': { mb: 1.25 }
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`faq-${i}-conteudo`}
              id={`faq-${i}-titulo`}
            >
              {/* h3 de verdade: mantém a hierarquia do documento para
                  leitor de tela e para quem renderiza a página */}
              <Typography component='h3' sx={{ fontWeight: 600, fontSize: '1rem' }}>
                {item.p}
              </Typography>
            </AccordionSummary>
            <AccordionDetails id={`faq-${i}-conteudo`}>
              <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                {item.r}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}

        <Typography sx={{ mt: 2.5, color: 'text.secondary', fontSize: '0.92rem' }}>
          Ainda com dúvida? Escreva para{' '}
          <MuiLink href='mailto:contato@umarkt.com.br' underline='hover'>
            contato@umarkt.com.br
          </MuiLink>{' '}
          ou veja a{' '}
          {/* href normal, e não Link do react-router, porque /faq.html é um
              arquivo estático servido pelo nginx — é justamente a versão que
              as IAs conseguem ler sem executar JavaScript */}
          <MuiLink href='/faq.html' underline='hover'>
            página completa de perguntas frequentes
          </MuiLink>
          .
        </Typography>
      </Leitura>
    </Secao>
  )
}

export default FaqSection
